import Vue from 'vue'
import { isQuotasEnabled } from '@/shared/Config'
import Store from '@/shared/store'
import { canAuditTrailRead } from '@/shared/aclList.js'
import { resolveFeatureFlag } from '@/shared/useFeatureFlag'

export default (route) => {
  return {
    Overview: {
      url: `organization/${route.params.organizationId}`,
      icon: 'fp4 fp4-overview'
    },
    Users: {
      regexp: /^\/organization\/\w*\/member.*/,
      url: `organization/${route.params.organizationId}/members`,
      icon: 'fp4 fp4-users'
    },
    Dataplants: {
      url: `organization/${route.params.organizationId}/projects`,
      icon: 'fp4 fp4-dataplants'
    },
    Quotas: {
      url: `organization/${route.params.organizationId}/quotas`,
      icon: 'fp4 fp4-organization-quotas',
      showing: isQuotasEnabled(),
      access: async () => {
        // Only organization admins can access quotas
        return Vue.acl(null, Store.getters.ORGANIZATION_SESSION).isAdmin()
      },
      addTooltip: 'aside.no-rights'
    },
    Plan: {
      url: `organization/${route.params.organizationId}/plan`,
      legacy: true,
      icon: 'fp4 fp4-organization-plan'
    },
    Auditing: {
      url: `organization/${route.params.organizationId}/auditing`,
      iconImage: 'auditing',
      showing: async () => await resolveFeatureFlag('audit_trail'),
      access: async () => {
        try {
          const { service, resource, action } = canAuditTrailRead
          return Vue.acl(null, Store.getters.ORGANIZATION_SESSION).can(service, resource, action)
        } catch (err) {
          this.$fpuiMessageBlock.pop('error', err.message)
        }
      },
      addTooltip: 'aside.no-rights'
    },
    Settings: {
      url: `organization/${route.params.organizationId}/settings`,
      icon: 'fp4 fp4-resources'
    }
  }
}
